import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQuery } from '@tanstack/react-query'

export const usePopularProductList = (id: string) => {
  return useQuery(queries.products.popular(id))
}
